import { observable, action, makeObservable } from 'mobx';
import { ProrationRuleFilters } from 'typings/enums';

const ruleCategories: {[key: number]: ProrationRuleFilters} = {
    1: ProrationRuleFilters.HireDate,
    2: ProrationRuleFilters.PayEffectiveDate
};

export class ProrationRuleFilter {
    ruleCategoryId: number;
    ruleCategoryName: ProrationRuleFilters;
    @observable ruleCategoryStartValue: Nullable<string>;
    @observable ruleCategoryEndValue: Nullable<string>;

    constructor(categoryId: number, startValue: Nullable<string> = null, endValue: Nullable<string> = null) {
        makeObservable(this);
        this.ruleCategoryId = categoryId;
        this.ruleCategoryName = ruleCategories[categoryId];
        this.ruleCategoryStartValue = startValue;
        this.ruleCategoryEndValue = endValue;
    }

    @action
    setStartValue(value: string): void {
        this.ruleCategoryStartValue = value;
    }

    @action
    setEndValue(value: string): void {
        this.ruleCategoryEndValue = value;
    }
}